import { useEffect, useState } from "react";
import { css } from "styled-components";

// The three-column cards of Manage Groups as one list (quick and warm-up):
// when the middle column cannot hold the Session Length row, the codes and
// Session Length move under the header instead of spilling out of the card.

// What the wide layout leaves the middle column: the card's width minus its
// right padding, the left and right columns and the two gaps between them.
export const CARD_RIGHT_PADDING = 24;
export const LEFT_COLUMN = 482;
export const RIGHT_COLUMN = 96;
export const COLUMN_GAP = 24;
const WIDE_FIXED_WIDTH = CARD_RIGHT_PADDING + LEFT_COLUMN + RIGHT_COLUMN + 2 * COLUMN_GAP;
export const SESSION_ROW_GAP = 16;

// The entry's border box when the browser reports it (one box, or a list of
// one in current browsers); else the element's rect.
const borderBoxWidth = (entry, element) => {
  const box = entry?.borderBoxSize;
  const size = Array.isArray(box) ? box[0] : box;
  return size ? size.inlineSize : element.getBoundingClientRect().width;
};

// The width the Session Length row needs on one line: its label group, the
// gap and the select frame, each at its own (unwrapped) width.
const sessionRowWidth = (sessionRow) => {
  const [labelGroup, selectFrame] = sessionRow.children;
  return labelGroup.getBoundingClientRect().width + SESSION_ROW_GAP + selectFrame.getBoundingClientRect().width;
};

// Narrow when the middle column the wide layout leaves cannot hold the Session
// Length row: the codes and Session Length then move under the header. The
// label group is watched too, so a late font is measured again.
export const useNarrow = (cardRef, sessionRowRef) => {
  const [narrow, setNarrow] = useState(false);
  useEffect(() => {
    const card = cardRef.current;
    const sessionRow = sessionRowRef.current;
    if (!card || !sessionRow || typeof window.ResizeObserver !== "function") return undefined;
    const observer = new window.ResizeObserver((entries) => {
      const cardWidth = borderBoxWidth(entries.find((entry) => entry.target === card), card);
      setNarrow(cardWidth - WIDE_FIXED_WIDTH < sessionRowWidth(sessionRow));
    });
    observer.observe(card);
    observer.observe(sessionRow.children[0]);
    return () => observer.disconnect();
  }, [cardRef, sessionRowRef]);
  return narrow;
};

// The narrow layout, one fragment per part of the card.
export const narrowRow = css`
  flex-wrap: wrap;
  gap: 16px ${COLUMN_GAP}px;
`;

export const narrowLeftColumn = css`
  flex: 0 1 ${LEFT_COLUMN}px;
  min-width: 0;
`;

export const narrowMiddleColumn = css`
  box-sizing: border-box;
  flex: 1 1 100%;
  padding: 0 24px;
`;

// The kebab stays at the card's top right while the middle wraps.
export const narrowRightColumn = css`
  position: absolute;
  right: ${CARD_RIGHT_PADDING}px;
  top: 16px;
`;

export const narrowSessionRow = "flex-wrap: wrap;";
